var _path, _path2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgVideoEye(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 23,
    height: 16,
    viewBox: "0 0 23 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.11544 8.71318C1.97925 8.49754 1.91115 8.38972 1.87304 8.22342C1.8444 8.0985 1.8444 7.9015 1.87304 7.77658C1.91115 7.61028 1.97925 7.50246 2.11543 7.28682C3.24084 5.50484 6.59071 1 11.6957 1C16.8007 1 20.1506 5.50484 21.276 7.28682C21.4122 7.50246 21.4803 7.61028 21.5184 7.77658C21.547 7.9015 21.547 8.0985 21.5184 8.22342C21.4803 8.38972 21.4122 8.49754 21.276 8.71318C20.1506 10.4952 16.8007 15 11.6957 15C6.59071 15 3.24084 10.4952 2.11544 8.71318Z",
    stroke: "#091523",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11.6957 11C13.3526 11 14.6957 9.65685 14.6957 8C14.6957 6.34315 13.3526 5 11.6957 5C10.0389 5 8.69572 6.34315 8.69572 8C8.69572 9.65685 10.0389 11 11.6957 11Z",
    stroke: "#091523",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgVideoEye);
export default __webpack_public_path__ + "static/media/videoEye.b283cbc610aeff8d8419a0325800294a.svg";
export { ForwardRef as ReactComponent };